import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=1bbeab92&scoped=true&"
import script from "./Affiliate.vue?vue&type=script&lang=js&"
export * from "./Affiliate.vue?vue&type=script&lang=js&"
import style0 from "./Affiliate.vue?vue&type=style&index=0&id=1bbeab92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbeab92",
  null
  
)

export default component.exports